import React from 'react'

import { ReactRenderer, ADFEncoder } from '@atlaskit/renderer';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';
import { ProviderFactory } from '@atlaskit/editor-common'

const wikiRenderer = (props) => {

    const adfEncoder = new ADFEncoder( () => new WikiMarkupTransformer())

    // const providerFactory = (mentionProvider) => ProviderFactory.create({
    //     mentionProvider
    // })

    let { value, /*mentionProvider*/ } = props
    //let provFact = providerFactory(mentionProvider)
    //let doc = value ? adfEncoder.encode(value) : null
    
    return (
        <ReactRenderer document={value} /*dataProviders={provFact}*/ />
    )

}

export default wikiRenderer


// WEBPACK FOOTER //
// ./client/src/components/AtlasWikiRenderer.js